<template>
  <div>
    <div @click.stop="open = !open">
      <slot name="activator">
        <v-btn fab bottom right color="accent">
          <v-icon>Contact</v-icon>
        </v-btn>
      </slot>
    </div>

    <v-dialog scrollable v-model="open" width="400">
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title black--text">
          Cancel of {{ appointment.patient_profile.firstname }}
        </v-card-title>
        <v-card-text>
          <v-form v-model="Form.valid">
            <v-container grid-list-xs :class="$vuetify.breakpoint.mdAndUp ? 'pa-5' : ''">
              <v-layout row wrap>
                <v-flex xs12>
                  <p>Patient's Money which pay for appointment will back to their Wallet</p>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    outlined
                    label="Reason for cancel"
                    auto-grow
                    v-validate="'required'"
                    :error-messages="errors.collect('message')"
                    data-vv-name="message"
                    v-model="Form.cancel_reason"
                    clearable
                  ></v-textarea>
                </v-flex>
                <!-- <v-flex xs12>
                  <v-radio-group label="Type" mandatory v-model="Form.type" row>
                    <v-flex xs12 >
                      <v-radio :disabled="!patient.user.tel && patient.user.tel_confirmed" label="SMS" value="sms"></v-radio>
                    </v-flex>
                    <v-flex xs12>
                      <v-radio :disabled="!patient.user.email && patient.user.email_confirmed" label="Email" value="email"></v-radio>
                    </v-flex>
                  </v-radio-group>
                </v-flex> -->
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions class="pb-3 pr-5">
          <v-spacer></v-spacer>
          <v-btn text @click="(open = false), resetFormError(null, Form)">Cancel</v-btn>
          <v-btn color="primary" text :disabled="!Form.valid" @click="confirmToCreate">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Forms from '../form/form';
import formMixin from '../Mixins/form';
import appointmentService from '../services/appointment';

export default {
  mixins: [formMixin],
  props: {
    // value: {
    //   type: Boolean,
    //   default: false
    // },
    appointment: {
      type: Object,
      default() {},
    },
  },
  data() {
    return {
      open: false,
      Form: new Forms({
        data: () => ({
          status: 'cancelled',
          cancel_reason: '',
        }),
      }),
    };
  },
  computed: {},
  watch: {},
  methods: {
    confirmToCreate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$root
            .$confirm('Cancel', 'Are you confirm to cancel?', {
              color: 'primary',
              submitText: 'Yes',
            })
            .then((confirm) => {
              if (confirm) this.sendMessage();
            });
        }
      });
    },
    sendMessage() {
      appointmentService
        .cancel(this.appointment.id, this.Form)
        .then(() => {
          // success callback
          this.open = false;
          this.$emit('success', this.appointment.id);
          this.$notify({
            title: 'Success',
            text: `Cancel ${this.appointment.id} already!!`,
            type: 'success',
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {},
  components: {},
};
</script>
